export class Board {
	constructor(width, height, data = null) {
		this.width = width;
		this.height = height;
		this.data =
			data === null ? new Array(this.width * this.height).fill("") : data;
	}

	toJSON() {
		return { width: this.width, height: this.height, data: this.data };
	}

	setTile(x, y, string) {
		this.data[x + y * this.width] = string.toString();
	}

	getTile(x, y) {
		return this.data[x + y * this.width];
	}

	resize(w, h, dx = 0, dy = 0) {
		const data = new Array(w * h);
		for (let i = 0; i < data.length; ++i) {
			let x = i % w;
			let y = (i - x) / w;
			x += dx;
			y += dy;

			if (x < 0 || x >= this.width || y < 0 || y >= this.height) {
				data[i] = "";
				continue;
			}

			data[i] = this.data[x + y * this.width];
		}

		this.width = w;
		this.height = h;
		this.data = data;
	}
}
